import React from 'react';
import ColorProperty from './ColorProperty';
import NumberProperty from './NumberProperty';
import PropertyBase, { IBasePropertyProps } from './PropertyBase';
import { IContextMenuItem } from '../../interfaces/Misc';

interface IColorAlphaPropertyProps extends IBasePropertyProps
{
	name: string;
	valueColor: string;
	defaultValueColor?: string;
	onChangeCallbackColor?: (newValue: string) => void;
	onCommitCallbackColor?: (newValue: string) => void;
	contextMenuAddonsColor?: IContextMenuItem[];
	contextMenuOverrideColor?: IContextMenuItem[];
	multivaluesColor?: boolean;
	valueAlpha: number;
	defaultValueAlpha?: number;
	onChangeCallbackAlpha?: (newValue: number) => void;
	onCommitCallbackAlpha?: (newValue: number) => void;
	contextMenuAddonsAlpha?: IContextMenuItem[];
	contextMenuOverrideAlpha?: IContextMenuItem[];
	min?: number;
	max?: number;
	step?: number;
	postfixLabel?: React.ReactNode;
	multivaluesAlpha?: boolean;
}

export default function ColorAlphaProperty(props: IColorAlphaPropertyProps)
{
	return (
		<PropertyBase {...props}
			data-name={props["data-name"]}
		>
			<ColorProperty
				data-name={props["data-name"]}
				key={props.name + '_color'}
				value={props.valueColor}
				defaultValue={props.defaultValueColor}
				onChangeCallback={props.onChangeCallbackColor}
				onCommitCallback={props.onCommitCallbackColor}
				contextMenuAddons={props.contextMenuAddonsColor}
				contextMenuOverride={props.contextMenuOverrideColor ? props.contextMenuOverrideColor : props.contextMenuOverride }
				multivalues={props.multivaluesColor}
			/>
			<NumberProperty
				data-name={props["data-name"]}
				cellclass={"narrowField"}
				key={props.name + '_alpha'}
				value={props.valueAlpha}
				defaultValue={props.defaultValueAlpha}
				onChangeCallback={props.onChangeCallbackAlpha}
				onCommitCallback={props.onCommitCallbackAlpha}
				contextMenuAddons={props.contextMenuAddonsAlpha}
				contextMenuOverride={props.contextMenuOverrideAlpha ? props.contextMenuOverrideAlpha : props.contextMenuOverride }
				min={props.min}
				max={props.max}
				step={props.step}
				multivalues={props.multivaluesAlpha}
				postfixLabel={props.postfixLabel}
			/>
		</PropertyBase>
	);
}
